import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页 - Nivi' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: { title: 'Nivi蛋 - Nivi' }
  },
  {
    path: '/products/children',
    name: 'ProductChildren',
    component: () => import('@/views/ProductChildren.vue'),
    meta: { title: 'Nivi蛋 - Nivi' }
  },
  {
    path: '/products/robot',
    name: 'RobotProductSeries',
    component: () => import('@/views/ProductSeries.vue'),
    props: { seriesType: 'robot' },
    meta: { title: 'Nivi机器人 - Nivi' }
  },
  {
    path: '/products/dog',
    name: 'DogProductSeries',
    component: () => import('@/views/ProductSeries.vue'),
    props: { seriesType: 'dog' },
    meta: { title: 'Nivi狗 - Nivi' }
  },
  {
    path: '/products/robot/:slug',
    name: 'RobotProductDetail',
    component: () => import('@/views/ProductRoleDetail.vue'),
    props: route => ({ seriesType: 'robot', slug: route.params.slug }),
    meta: { title: '机器人详情 - Nivi' }
  },
  {
    path: '/products/dog/:slug',
    name: 'DogProductDetail',
    component: () => import('@/views/ProductRoleDetail.vue'),
    props: route => ({ seriesType: 'dog', slug: route.params.slug }),
    meta: { title: '机器狗详情 - Nivi' }
  },
  {
    path: '/products/ring',
    name: 'RingSeries',
    component: () => import('@/views/RingSeries.vue'),
    meta: { title: 'ODOY智能戒指 - Nivi' }
  },
  {
    path: '/products/ring/:slug',
    name: 'RingDetail',
    component: () => import('@/views/RingDetail.vue'),
    props: true,
    meta: { title: '智能戒指详情 - Nivi' }
  },
  {
    path: '/products/ring/*',
    name: 'RingInvalidPath',
    component: () => import('@/views/RingDetail.vue'),
    props: { slug: '__invalid_ring_path__' },
    meta: { title: '智能戒指详情 - Nivi' }
  },
  {
    path: '/products/:productCode',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: { title: '产品详情 - Nivi' }
  },
  {
    path: '/technology',
    name: 'Technology',
    component: () => import('@/views/Technology.vue'),
    meta: { title: '技术引擎 - Nivi' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们 - Nivi' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: { title: '新闻动态 - Nivi' }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: { title: '新闻详情 - Nivi' }
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('@/views/Cooperation.vue'),
    meta: { title: '商务合作 - Nivi' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  document.title = (to.meta && to.meta.title) || 'Nivi'
})

export default router
